export default __webpack_public_path__ + "static/media/chillrx_case_study_hero.png.webp";